import { render, staticRenderFns } from "./FormSTI.vue?vue&type=template&id=4c6d8e90&scoped=true&"
import script from "./FormSTI.vue?vue&type=script&lang=js&"
export * from "./FormSTI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6d8e90",
  null
  
)

export default component.exports